import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { IonicModule } from '@ionic/angular';
import { MainHeaderComponent } from './components/main-header/main-header.component';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatTabsModule } from '@angular/material/tabs';
import { inputTime } from './pipes/input-time.pipe';
import { BreadcrumbsComponent } from './components/breadcrumbs/breadcrumbs.component';
import { ModeComponent } from './components/mode/mode.component';
import { MatMenuModule } from '@angular/material/menu';
import { MeteoGridComponent } from './components/meteo-grid/meteo-grid.component';
import { AlarmsGridComponent } from './components/alarms-grid/alarms-grid.component';
import { DirtyMessageComponent } from './components/dirty-message/dirty-message.component';
import { SanitizeTextPipe } from './pipes/sanitize-text.pipe';
import { SafeHtmlPipe } from './pipes/safe-html.pipe';
import { FieldsHeaderComponent } from './components/fields-header/fields-header.component';
import { MetricsHeaderComponent } from './components/metrics-header/metrics-header.component';
import { WeekDaysSelectorComponent } from './components/week-days-selector/week-days-selector.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxPaginationModule } from 'ngx-pagination';
import { TerminalTableWrapperComponent } from './components/terminal-table-wrapper/terminal-table-wrapper.component';
import { FilterByPropertyPipe } from './pipes/filter-by-property.pipe';
import { DemoAlertComponent } from './components/demo-alert/demo-alert.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { AuthModule } from '../auth/auth.module';
import { AlarmGridTagPipe } from './pipes/alarm-grid-tag.pipe';
import { AlarmGridTitlesPipe } from './pipes/alarm-grid-titles.pipe';
import { ToHexPipe } from './pipes/to-hex.pipe';
import { SortPipe } from './pipes/sort.pipe';
import { BadgesPipe } from './pipes/badges.pipe';
import { DemoFieldCardComponent } from './components/demo-field-card/demo-field-card.component';
import { SecondsToTimePipe } from './pipes/seconds-to-time.pipe';
import { TerminalEnabledPipe } from './pipes/terminal-enabled.pipe';
import { SortableHeaderDirective } from './directives/sortable-header.directive';
import { WaterSystemsComponent } from './components/water-systems/water-systems.component';
import { WaterSystemsModule } from './components/water-systems/water-systems.module';
import { GraphicHeaderComponent } from './components/graphic-header/graphic-header.component';
import { SelectedSensorsComponent } from '../megapop-common/selected-sensors/selected-sensors.component';
import { SelectedDatesComponent } from '../megapop-common/selected-dates/selected-dates.component';
import { InfoPillComponent } from './components/info-pill/info-pill.component';
import { MagnitudeValuePrecisionPipe } from './pipes/magnitude-value-precision.pipe';
import { App360SharedModule } from '@nutricontrol/app360-shared';
import { TerminalPlaceholderDataComponent } from './components/terminal-placeholder-data/terminal-placeholder-data.component';
import { TerminalTemporaryDisabledAlertComponent } from './components/terminal-temporary-disabled-alert/terminal-temporary-disabled-alert.component';
import { EquipmentTemporaryDisabledDataComponent } from './components/equipment-temporary-disabled-data/equipment-temporary-disabled-data.component';
import { TerminalTypeNamePipe } from './pipes/terminal-type-name.pipe';
import { RemoteControlComponent } from './components/remote-control/remote-control.component';
import { FloatingConfigComponent } from './components/floating-config/floating-config.component';
import { MatButtonModule } from '@angular/material/button';

@NgModule({
  declarations: [
    MainHeaderComponent,
    inputTime,
    BreadcrumbsComponent,
    ModeComponent,
    MeteoGridComponent,
    AlarmsGridComponent,
    DirtyMessageComponent,
    SanitizeTextPipe,
    SafeHtmlPipe,
    FieldsHeaderComponent,
    MetricsHeaderComponent,
    WeekDaysSelectorComponent,
    TerminalTableWrapperComponent,
    FilterByPropertyPipe,
    DemoAlertComponent,
    AlarmGridTagPipe,
    AlarmGridTitlesPipe,
    ToHexPipe,
    SortPipe,
    BadgesPipe,
    DemoFieldCardComponent,
    SecondsToTimePipe,
    TerminalEnabledPipe,
    SortableHeaderDirective,
    WaterSystemsComponent,
    GraphicHeaderComponent,
    InfoPillComponent,
    MagnitudeValuePrecisionPipe,
    TerminalPlaceholderDataComponent,
    TerminalTemporaryDisabledAlertComponent,
    EquipmentTemporaryDisabledDataComponent,
    TerminalTypeNamePipe,
    RemoteControlComponent,
    FloatingConfigComponent,
  ],
  imports: [
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    IonicModule,
    RouterModule,
    MatExpansionModule,
    MatTabsModule,
    MatMenuModule,
    NgxPaginationModule,
    MatTooltipModule,
    AuthModule,
    WaterSystemsModule,
    SelectedSensorsComponent,
    SelectedDatesComponent,
    App360SharedModule,
    MatButtonModule,
  ],
  exports: [
    MainHeaderComponent,
    inputTime,
    BreadcrumbsComponent,
    ModeComponent,
    WaterSystemsComponent,
    MeteoGridComponent,
    AlarmsGridComponent,
    DirtyMessageComponent,
    SanitizeTextPipe,
    SafeHtmlPipe,
    FieldsHeaderComponent,
    MetricsHeaderComponent,
    WeekDaysSelectorComponent,
    TerminalTableWrapperComponent,
    FilterByPropertyPipe,
    DemoAlertComponent,
    ToHexPipe,
    SortPipe,
    App360SharedModule,
    SecondsToTimePipe,
    BadgesPipe,
    TerminalEnabledPipe,
    DemoFieldCardComponent,
    SortableHeaderDirective,
    InfoPillComponent,
    MagnitudeValuePrecisionPipe,
    GraphicHeaderComponent,
    TerminalPlaceholderDataComponent,
    TerminalTemporaryDisabledAlertComponent,
    EquipmentTemporaryDisabledDataComponent,
    TerminalTypeNamePipe,
    RemoteControlComponent,
    FloatingConfigComponent,
  ],
  providers: [MainHeaderComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppCommonsModule {}
